// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"eca1ac23","453":"42b97e38","564":"8ec0c72a","615":"13d34461"}[chunkId] + ".chunk.js";
};